export interface Mcc {
  mcc: string;
  edited_description: string;
  combined_description: string;
  usda_description: string;
  irs_description: string;
  irs_reportable: string;
  id: number;
}

export enum MccActionTypes {
  FETCH = "@@mcc/FETCH",
  FETCH_SUCCESS = "@@mcc/FETCH_SUCCESS",
  FETCH_ERROR = "@@mcc/FETCH_ERROR",
}

export interface MccState {
  readonly loading: boolean;
  readonly data: Mcc[];
  readonly errors?: string;
}
